var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keywordSearch"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.words.label))]),_c('form-keyword-recommend')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }